import React from "react"
import {connect} from 'react-redux'
import { Link } from "react-router-dom"
import { replace } from 'connected-react-router'
import { isEqual, get, isString, flatten, keys } from "lodash"
import { Table, Checkbox, Glyphicon, FormControl } from "react-bootstrap"
import moment from "moment-timezone"
import { flag } from "country-code-emoji"
import { parse, stringify } from "query-string"

import data from "../../../../../data"
import { typeLabel, reservationName, Pager } from "./table.aux"
import { getReservationsInf } from '../../store/selectors'

import "./tables.less"
import "./ReservationsTable.less"

/**
 *
 */

function cut(s, n = 20) {
  if (s.length > n) return s.substr(0, n) + "…"
  else return s
}

const _parenRegex = /\(([^)]+)\)/

const reservationTime = r => {
  let day = r.day || get(r, "formData.dayString", "")
  if (day.includes("(")) { // :)
    day = _parenRegex.exec(day)[1]
  }

  return `${day} ${r.shift || get(r, "formData.time", "")}`
}

const partnerCell = reservation => {
  const p = reservation.partnerId && data.partners.find(p => p._id === reservation.partnerId)

  return (
    <div className="partner-cell">
      <img alt={`${p ? p.name : "chinespain"} logo`} src={p ? p.logo : "/static/favicon.png"} />
      <div>{p ? p.name : ""}</div>
    </div>
  )
}

const calendar = date => moment(date).locale("es_es").calendar(null, {
  sameDay: `[Hoy]`,
  lastDay: `[Ayer]`,
  lastWeek: '[El] dddd [pasado] (DD/MM/YYYY)',
  sameElse: 'DD/MM/YYYY'
})

type Props = {
  reservations: any,
  partnerMode: boolean
}

class ReservationsTable extends React.PureComponent {
  constructor(props) {
    super(props)
    this.pageSizes = [100, 250, 500]
    this.state = {
      sortKey: "timestamp",
    }
  }


  props: Props

  componentDidMount() {
    if (this.props.reservations) {
      this.setState({reservations: this.props.reservations, reservationsLength: this.props.reservations.length})
    }
    else {
      this.props.reservationsInf.then(reservationsInf => {
        this.setState({reservations: reservationsInf.reservations, reservationsLength: reservationsInf.length})
      })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.reservations) {
      this.setState({reservations: nextProps.reservations, reservationsLength: nextProps.reservations.length})
    }
    else {
      nextProps.reservationsInf.then(reservationsInf => {
        if (!isEqual(reservationsInf.reservations, this.props.reservationsInf.reservations)) {
          this.setState({reservations: reservationsInf.reservations, reservationsLength: reservationsInf.length})
        }
      })
    }
  }


  updateQuery(newQuery) {
    this.props.updateSearch({...this.props.query, ...newQuery})
  }

  handleSort(sortColumn) {
    if (sortColumn === this.props.query.sortColumn) {
      this.updateQuery({sortDirection: this.props.query.sortDirection == 1 ? -1 : 1})
    }
    else {
      this.updateQuery({
        sortColumn,
        sortDirection: 1
      })
    }
  }

  render() {
    const {ref, sortColumn} = this.props.query
    const onlyPaid = this.props.query.onlyPaid == "true"
    const page = this.props.query.page || 0
    const pageSize = this.props.query.pageSize || this.pageSizes[0]
    const reservations = this.state.reservations || []

    const dataWithSep = flatten(reservations.map((r, i) => {
      if (i == 0) return [calendar(r.timestamp), r]
      else if (moment(r.timestamp).format('dddd MMMM YYYY') != moment(reservations[i - 1].timestamp).format('dddd MMMM YYYY')) {
        return [calendar(r.timestamp), r]
      }
      else return r
    }))
      .filter(r => (onlyPaid == "true" && r.isPaid) || onlyPaid == "false" || !onlyPaid)

    const numPages = Math.ceil(this.state.reservationsLength / pageSize)

    const MyTh = ({label, col}) => (
      <th
        onClick={() => this.handleSort(col)}
        style={{ textDecoration: sortColumn === col ? "underline" : "none", cursor: "pointer" }}
      >
        <Glyphicon glyph="sort" />
        {label}
      </th>
    )

    return (
      <div className="ReservationsTable">
        {
          reservations && (
            <div>
              <div className="sticky">
                <label htmlFor="SupplierFilter">
                  {"Filtra por referencia: "}
                </label>
                <FormControl
                  className="input"
                  value={ref}
                  onChange={evt => this.updateQuery({ref: evt.target.value})}
                />
                <Checkbox
                  checked={onlyPaid}
                  onChange={evt => this.updateQuery({onlyPaid: evt.target.checked})}
                >
                  Mostrar solo pagados
                </Checkbox>
              </div>
              {
                numPages > 0 && this.state.reservationsLength > this.pageSizes[0] && (
                  <Pager
                    sizes={this.pageSizes}
                    size={pageSize}
                    numPages={numPages}
                    page={page}
                    onChange={page => this.updateQuery({page})}
                    onSizeChange={pageSize => {
                      this.updateQuery({page: 0, pageSize})
                    }}
                  />
                )
              }

              <Table striped bordered hover className="cool-table table-fill reservations-table">
                <thead>
                  <tr>
                    { !this.props.partnerMode && (<th/>) }
                    <th>Id (c/s)</th>
                    <MyTh col="timestamp" label="Request time" />
                    <th key="n">{ !this.props.partnerMode ? "Name" : "Geo" }</th>
                    { !this.props.partnerMode && (<th>Phone</th>) }
                    <th>Query</th>
                    <MyTh col="date" label="Res. date" />
                    <MyTh col="type" label="Category" />
                    <th>Num. people</th>
                    <th>Place</th>
                    <MyTh col="isPaid" label="Paid" />
                    <MyTh col="eurPrice" label="Price" />
                    { !this.props.partnerMode && <MyTh col="partnerId" label="Partner" /> }
                  </tr>
                </thead>
                <tbody className="table-hover">
                  {
                    dataWithSep.length > 0
                      ? dataWithSep
                        .map(reservation => (
                          isString(reservation)
                            ? (
                              <tr>
                                <td colSpan="666" className="date-separator text-center">
                                  {reservation}
                                </td>
                              </tr>
                            )
                            : (
                              <tr key={reservation._id}>
                                {
                                  !this.props.partnerMode && (
                                    <td className="res-details text-center">
                                      <Link to={`/private/reservation/${reservation._id}`}>Ver detalles</Link>
                                    </td>
                                  )
                                }

                                <td>
                                  <div style={{ borderBottom: "1px solid grey" }}>
                                    {`${cut(reservation.clientId)}`}
                                  </div>
                                  <div>{`${cut(reservation.sessionId)}`}</div>
                                </td>
                                <td>{moment(reservation.timestamp).format("YY/MM/DD HH:mm")}</td>
                                <td key="n">
                                  {
                                    !this.props.partnerMode && (
                                      <div>
                                        <b>{reservation.name}</b>
                                        { reservation.wechat && (<div>
                                          Wx:
                                          {' '}
                                          {reservation.wechat}
                                        </div>) }
                                      </div>
                                    )
                                  }
                                  <div>
                                    {flag(reservation.ipCountry || "AQ")}
                                    {" "}
                                    {reservation.ipCity || "???"}
                                  </div>
                                </td>
                                {!this.props.partnerMode && (
                                  <td>
                                    {reservation.prefix}
                                    {` ${reservation.phone}`}
                                  </td>
                                )}
                                
                                <td>
                                  {
                                    keys(reservation.query)
                                      .map(key => <div key={key}>
                                        <b>{key}</b>
                                        :
                                        {' '}
                                        {reservation.query[key]}
                                      </div>)
                                  }
                                </td>
                                <td>{reservationTime(reservation)}</td>
                                <td>{typeLabel(reservation.type)}</td>
                                <td>{reservation.persons}</td>
                                <td>{reservationName(reservation)}</td>
                                <td>{reservation.isPaid ? "✅ Yea" : "Pending"}</td>
                                <td>
                                  <div>
                                    {Number(reservation.eurPrice).toFixed(2)}€
                                  </div>
                                  <div>({Number(reservation.yuanPrice).toFixed(2)}¥)</div>
                                </td>
                                {!this.props.partnerMode && <td>{partnerCell(reservation)}</td>}
                              </tr>
                            )
                        ))
                      : (
                        <tr>
                          <td colSpan="666">No se encontraron resultados</td>
                        </tr>
                      )
                  }
                </tbody>
              </Table>
            </div>
          )
        }
      </div>

    )
  }
}

const mapStateToProps = (state, props) => ({
  reservationsInf: !props.reservations && getReservationsInf(state, props),
  query: parse(state.router.location.search)
})

const mapDispatchToProps = dispatch => ({
  updateSearch: query => dispatch(replace({search: stringify(query)})),
})


export default connect(mapStateToProps, mapDispatchToProps)(ReservationsTable)



// WEBPACK FOOTER //
// ./src/app/admin/components/tables/ReservationsTable.jsx